import { LineChart } from "@/global/components/line-chart";
import "./index.less"
import { qDataBase } from "@/global/interface/project-device/quantity";
import { useEffect, useState } from "react";
import { queryInfluxCurrentData, queryInfluxDataList } from "@/api/influx/influx";
import { TimeValue } from "@/global/interface/time-value";
import TnMessage from "@/global/components/message";
import { findSensorParameterDtoBySensorIds, getSensorByPrimitiveUuid } from "@/api/device/sensor";
import { Sensor, SensorParameter } from "@/global/interface/device/sensor";
import { emitter } from "@/global/listeners";
import { Emit_Event } from "@/enums/emit-event";
import { getDateName } from "@/global/utils/date-utils";
interface IProps {
    sensorId: number
}
export default function WindSecondPanel(props: IProps) {

    // 风速数据
    const [windSpeedData, setWindSpeedData] = useState<number[][]>([])
    // 风速参数
    const [wsParam, setWsParam] = useState<SensorParameter>();

    const [endTime, setEndTime] = useState<number>(null)

    useEffect(() => {
        generateData()
        emitter.on(Emit_Event.LINE_CHART_UPDATE, generateData)

        return (() => {
            emitter.off(Emit_Event.LINE_CHART_UPDATE, generateData)
        })
    }, [props.sensorId])

    useEffect(() => {
        flushData();
        const interval = setInterval(() => {
            flushData();
        }, 3000)

        return () => {
            clearInterval(interval)
        }
    }, [wsParam, endTime])

    const generateData = () => {

        if (!props.sensorId) return
        findSensorParameterDtoBySensorIds([props.sensorId]).then(res => {
            let sensorParams: SensorParameter[] = res.data || []
            // 获取symblo类型为ws的参数
            let wsParams: SensorParameter = sensorParams.find(item => item.symbol == "ws")
            // console.log('wsParams', wsParams)
            setWsParam(wsParams);
        }).catch(e => {
            TnMessage.error("获取数据失败！")
        })
    }

    const flushData = () => {
        if (!wsParam) return;
        queryInfluxDataList(wsParam.id, "ws", "sensor", {
            limit: 100,
            endTime: endTime
        }).then(res => {
            let valueList: TimeValue[] = res.data || []
            // 组合成数据
            let data = []
            for (let i = 0; i < valueList?.length; i++) {
                data.push([valueList[i].time, valueList[i].value])
            }
            setWindSpeedData(data)
        }).catch(() => {
            TnMessage.error("获取失败！")
        })
    }

    const getChartAxisXLabel = (value: number) => {
        const date = new Date(Number(value));
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0).getTime();
        if (date.getTime() < today) {
            return `${date.getMonth() + 1}-${date.getDate()} ${hours}:${minutes}`
        }
        return `${hours}:${minutes}`;
    }

    const getDateTitle = () => {
        if (windSpeedData?.length > 0) {
            return getDateName(windSpeedData[windSpeedData.length - 1][0])
        } else {
            return "无数据"
        }
    }

    return (
        <div className="wind-chart">
            <LineChart
                chartTitle="风速"
                chartValue={getDateTitle()}
                lineData={windSpeedData}
                getAxisXLabel={getChartAxisXLabel}
                xLabel="时间"
                yLabel="m/s"
                toolTipXLabel="时间"
                toolTipYLabel="风速"
                tLine_1={wsParam?.t2}
                tLine_2={wsParam?.t3}
                tLine_3={wsParam?.t4}
                onChangeEndTime={(e) => { setEndTime(e) }}
            />
        </div>
    )
}